<script>
import { mapGetters } from 'vuex';
import { useUISettings } from 'dashboard/composables/useUISettings';
import PageCard from './components/PageCard.vue';
import CommentsLayout from './CommentsLayout.vue';
import BaseCommentsHeader from './CommentsHeader.vue';

export default {
  components: {
    CommentsLayout,
    BaseCommentsHeader,
    PageCard,
  },
  props: {
    postHeader: {
      type: String,
    },
    postType: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { uiSettings } = useUISettings();
    return { uiSettings };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'facebookPages/getUIFlags',
      pagesList: 'facebookPages/getPages',
    }),

    groupedPages() {
      if (!this.pagesList?.length) return {};

      const groups = {};
      this.pagesList.forEach(page => {
        const label = page.label || '';
        if (!groups[label]) groups[label] = [];
        groups[label].push(page);
      });

      return groups;
    },

    sortedGroups() {
      const entries = Object.entries(this.groupedPages);

      const withLabel = entries.filter(([label]) => label !== '');
      const withoutLabel = entries.filter(([label]) => label === '');

      withLabel.sort(([a], [b]) => a.localeCompare(b));

      return [...withLabel, ...withoutLabel];
    },

    cardsData() {
      const cards = [];

      this.sortedGroups.forEach(([label, pagesGroup]) => {
        if (label) {
          cards.push({
            pageId: pagesGroup[0].id,
            title: this.formatLabelName(label),
            image: pagesGroup[0].avatar_url,
            description: `${pagesGroup.length} ${pagesGroup.length === 1 ? 'página' : 'páginas'}`,
            isGroup: true,
            pages: pagesGroup,
          });
        } else {
          pagesGroup.forEach(page => {
            cards.push({
              pageId: page.id,
              title: page.name,
              image: page.avatar_url,
              description: '',
              isGroup: false,
            });
          });
        }
      });

      return cards;
    },
  },
  mounted() {
    this.fetchPages();
  },
  methods: {
    fetchPages() {
      this.$store.dispatch('facebookPages/get');
    },

    formatLabelName(label) {
      if (!label) return '';

      return label
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },
  },
};
</script>

<template>
  <CommentsLayout
    :is-loading="uiFlags.isFetching"
    loading-message="Verificando páginas..."
    :no-records-found="!pagesList.length"
    no-records-message="Nenhuma página encontrada. Adicione uma página para começar"
  >
    <template #header>
      <BaseCommentsHeader
        :header-title="postHeader"
        :feature-name="postHeader.toLowerCase()"
      />
    </template>

    <template #body>
      <section class="flex flex-wrap gap-8 p-6">
        <PageCard
          v-for="card in cardsData"
          :key="card.pageId"
          :page-id="card.pageId"
          :title="card.title"
          :image="card.image"
          :description="card.description"
          :post-type="postType"
          :is-group="card.isGroup"
          :pages="card.pages"
        />
      </section>
    </template>
  </CommentsLayout>
</template>
